import { IPixiAppCreateOptions, IPixiAppCreationResult } from "./pixi-app.service.interface";

/**
 * PixiSpine must load after pixi.js / pixi.js-legacy but before "new PIXI.Application"
 * Because PixiSpine alter/mutates the internal structure of PIXI
 */
async function loadPixi() {
    const PIXI = await import("pixi.js-legacy");
    // const PIXI = await import("pixi.js");
    // const PixiSpine = await import("pixi-spine");
    const PixiSpine = await import("@pixi-spine/all-3.8");
    return {PIXI, PixiSpine};
}

export async function createPixiApplication(options: IPixiAppCreateOptions): Promise<IPixiAppCreationResult> {
    const {PIXI, PixiSpine} = await loadPixi();
    let app = new PIXI.Application({
        backgroundAlpha: 0,
        width: options.width,
        height: options.height,
        antialias: true,
        forceCanvas: !!options.force2DCanvasContext
    });

    const dispose = () => {
        try {
            app.view.removeEventListener("webglcontextlost", contextLostHandler, false);
            app.stop();
            app.destroy(true, true);
            app = undefined;
        } catch (err) {
            console.error('Failed to dispose pixi application', err);
        }

    };

    const contextLostHandler = (_e: WebGLContextEvent) => {
        if (options.onContextLost) {
            options.onContextLost();
        }
        if (options.selfDestroyOnContextLost) {
            dispose();
        }
    };

    app.view.addEventListener("webglcontextlost", contextLostHandler, false);

    return {app, canvas: app.view, dispose, PixiSpine};
}
